import { FC, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Role } from '../role';
import { CustomerStep } from './customer-step';
import { SelectRoleStep } from './select-role-step';
import { ThirdPartyStep } from './third-party-step';

interface WizardLocationState {
    role: Role;
}

export const RequestAccessPage: FC = () => {
    const { pathname, state } = useLocation<WizardLocationState | undefined>();
    const history = useHistory();

    /*
     * Role lives in history state for browser Back/Forward consistency.
     * Local role rehydrates from it on mount to survive SPA unloads.
     */
    const [role, setRole] = useState<Role | undefined>(() => state?.role);

    const handleNext = (nextRole: Role) => {
        setRole(nextRole);
        history.push(pathname, { role: nextRole } satisfies WizardLocationState);
    };

    const handleBack = () => {
        history.goBack();
    };

    return !state ? (
        <SelectRoleStep initialRole={role} onNext={handleNext} />
    ) : state.role === Role.ThirdParty ? (
        <ThirdPartyStep onBack={handleBack} />
    ) : (
        <CustomerStep onBack={handleBack} />
    );
};
RequestAccessPage.displayName = 'RequestAccessPage';
